import { render, staticRenderFns } from "./ComponentColumnMenu.vue?vue&type=template&id=211d501e&"
import script from "./ComponentColumnMenu.vue?vue&type=script&lang=js&"
export * from "./ComponentColumnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports